import { useIntl } from "react-intl";
import React from "react";
import FishContainer from "./fish.container";

function FishContainerIntl() {
    const intl = useIntl()
    return (
        <FishContainer intl={intl}></FishContainer>
    );
  }

  export default FishContainerIntl


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/fish/fish.intl.js